module.exports = {"title":"Train to Varanasi","date":"2017-05-12T20:30:00+05:30","path":"/2017-05-12-varanasi-train/","author":"HARRISON","body":"<p><img src=\"./snippet.jpg\" alt=\"Image\">\n<img src=\"./IMG_3521.jpg\" alt=\"Image\">\n<img src=\"./IMG_3522.jpg\" alt=\"Image\">\n<img src=\"./IMG_3526.jpg\" alt=\"Image\">\n<img src=\"./IMG_3529.jpg\" alt=\"Image\">\n<img src=\"./IMG_3531.jpg\" alt=\"Image\">\n<img src=\"./IMG_3550.jpg\" alt=\"Image\">\n<img src=\"./IMG_3554.jpg\" alt=\"Image\">\n<em>48°C!</em></p>\n"}


//////////////////
// WEBPACK FOOTER
// ./2017-05-12-photos/index.md
// module id = 1067
// module chunks = 0